module.exports = __webpack_public_path__ + "img/DE04396.64e41c02.png";